import React, { useState } from 'react';
import Search from "./widgets/Search";
import UploadOTUFile from "./widgets/UploadOTUFile";
import HorizontalColoredLine from './widgets/horizontal_line';
import { postFile } from './api';
import AlertComponent from './alertComponent';
import { useTheme } from '../theme/ThemeContext';
import CloseIconBlack from '../static/images/black_icons/x_icon_black.png';
import CloseIconWhite from '../static/images/x_icon.png';

const UploadBox = ({
    scatterplot,
    setUserID,
    setSelectedIcon,
    uploadResponse,
    setUploadResponse,
    currentUserID,
    setCurrentUserID,
    isLoading,
    setIsLoading,
    showNotification,
    setShowNotification
}) => {
    const [showAlert, setShowAlert] = useState(false);
    const [alertHeader, setAlertHeader] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [files, setFiles] = useState([]);
    const { theme } = useTheme();

    const CloseIcon = theme.name === 'light' ? CloseIconBlack : CloseIconWhite;

    const showAlertMessage = (header, message) => {
        setAlertHeader(header);
        setAlertMessage(message);
        setShowAlert(true);
    };

    const onFileChange = async (event) => {
        const selectedFiles = Array.from(event.target.files);
        const maxSize = 100 * 1024 * 1024; // 100MB

        for (const file of selectedFiles) {
            if (file.size > maxSize) {
                showAlertMessage(
                    'File Too Large',
                    `${file.name} exceeds 10MB limit`
                );
                return;
            }
        }

        // user ID
        const timestamp = new Date().getTime();
        const uniq = Math.random().toString(36).substring(2, 8);
        const uniqueID = `USER_${timestamp}_${uniq}`;

        const formData = new FormData();
        formData.append('user_id', uniqueID);
        selectedFiles.forEach((file, index) => {
            formData.append(`otu_files`, file);
        });

        try {
            setIsLoading(true);
            const response = await postFile(formData);
            setUploadResponse(response);
            setUserID(uniqueID);
            setCurrentUserID(uniqueID);
            setShowNotification(true);
        } catch (error) {
            console.error('Error uploading files:', error);
            showAlertMessage('Upload Error', 'Failed to upload files');
        } finally {
            setIsLoading(false);
        }
    };

    // Styles remain unchanged
    const uploadBoxStyle = {
        margin: '20px',
        padding: '20px',
        width: '300px',
        color: '#dadada',
        fontFamily: 'Arial',
        backgroundColor: theme.colors.overlay,
        borderRadius: '10px',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        transition: 'all 0.3s ease-in-out',
        overflow: 'display',
        position: 'relative',
    };

    const closeIconStyle = {
        position: 'absolute',
        top: '10px',
        right: '10px',
        width: '20px',
        height: '20px',
        cursor: 'pointer',
    };

    const loadingOverlayStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.name === 'light'
            ? 'rgba(255, 255, 255, 0.3)'
            : 'rgba(0, 0, 0, 0.3)',
        backdropFilter: 'blur(4px)',
        borderRadius: '10px',
        zIndex: 100,
    };

    const spinnerStyle = {
        width: '50px',
        height: '50px',
        border: `5px solid ${theme.name === 'light'
            ? 'rgba(0, 0, 0, 0.1)'
            : 'rgba(255, 255, 255, 0.3)'}`,
        borderRadius: '50%',
        borderTop: `5px solid ${theme.name === 'light'
            ? "#000"
            : '#fff'}`,
        animation: 'spin 1s linear infinite',
    };

    const selectUserID = (query) => {
        console.log('searching user:', query);
        setUserID(query);
        setCurrentUserID(query);
    }

    return (
        <>
            <div style={uploadBoxStyle}>
                <img
                    src={CloseIcon}
                    alt="Close"
                    style={closeIconStyle}
                    onClick={() => setSelectedIcon(null)}
                />
                <h2>Add your sample to the Microverse</h2>
                <UploadOTUFile onFileChange={onFileChange}>Upload OTU table</UploadOTUFile>

                <HorizontalColoredLine />
                <Search placeholder={"user ID"} onSearch={selectUserID} />

                {isLoading && (
                    <div style={loadingOverlayStyle}>
                        <div style={spinnerStyle}></div>
                        <style>{`
                            @keyframes spin {
                                0% { transform: rotate(0deg); }
                                100% { transform: rotate(360deg); }
                            }
                        `}</style>
                        {/* <p style={{ color: 'white', marginLeft: '15px' }}>Processing...</p> */}
                        <p style={{ color: theme.colors.text, marginLeft: '15px' }}>Processing...</p>
                    </div>
                )}
            </div>
            <AlertComponent
                header={alertHeader}
                message={alertMessage}
                isVisible={showAlert}
                onClose={() => setShowAlert(false)}
                autoClose={false}
            />
        </>
    );
}

export default UploadBox;